<template>
  <b-card no-body>
    <b-card-body>
      <h5 class="card-title">
        {{ title }}
        <hint v-show="titleHint">
          <span>{{ titleHint }}</span>
        </hint>
      </h5>

      <div>
        <b-row class="text-center">
          <b-col sm="4">
            <div class="mt-4">
              <p class="text-muted mb-1">
                {{ minText }}
                <hint v-show="minHint">
                  <span>{{ minHint }}</span>
                </hint>
              </p>
              <h5>{{ min ? min : '-' }}</h5>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="mt-4">
              <p class="text-muted mb-1">
                {{ maxText }}
                <hint v-show="maxHint">
                  <span>{{ maxHint }}</span>
                </hint>
              </p>
              <h5>{{ max ? max : '-' }}</h5>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="mt-4">
              <p class="text-muted mb-1">
                {{ avgText }}
                <hint v-show="avgHint">
                  <span>{{ avgHint }}</span>
                </hint>
              </p>
              <h5>{{ avg ? avg : '-' }}</h5>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "KeywordBottomStatCard",
  props: [
    'title',
    'max',
    'min',
    'avg',
    'minText',
    'maxText',
    'avgText',
    'minHint',
    'maxHint',
    'avgHint',
    'titleHint',
  ]
}
</script>

<style scoped>

</style>